import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

const TransactionStatus = ({ status, reason }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShowTooltip(false);
      }
    };

    if (showTooltip) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showTooltip]);

  const toggleTooltip = (e) => {
    e.stopPropagation();
    setShowTooltip(!showTooltip);
  };

  const handleMouseEnter = () => {
    if (window.innerWidth > 768) {
      setShowTooltip(true);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth > 768) {
      setShowTooltip(false);
    }
  };

  const formattedStatus = status?.charAt(0).toUpperCase() + status?.slice(1);

  if (status === "failed" && reason) {
    return (
      <div className="status-with-reason" ref={tooltipRef}>
        <span>{formattedStatus}</span>
        <i
          className="fas fa-info-circle info-icon"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={toggleTooltip}
        ></i>
        <div className={`reason-tooltip ${showTooltip ? "show" : ""}`}>
          {reason}
        </div>
      </div>
    );
  }

  return <span>{formattedStatus}</span>;
};

TransactionStatus.propTypes = {
  status: PropTypes.string.isRequired,
  reason: PropTypes.string,
};

export default TransactionStatus;
